import { render, staticRenderFns } from "./InvoiceReport.vue?vue&type=template&id=491c9a24"
import script from "./InvoiceReport.vue?vue&type=script&lang=ts"
export * from "./InvoiceReport.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports